import React from 'react';
import {compose} from 'recompose';
import {connect} from 'react-redux';
import { AppBar, UserMenu, MenuItemLink, userLogout, withDataProvider } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import SettingsIcon from '@material-ui/icons/Settings';

import actions from '../redux/user/actions';
import getActivityTime from '../redux/activity/selectors';
import {getUserFullName, getUserEmail} from '../redux/user/selectors';


const LIMIT_SECS = 900; // 15 min inactivity will call logout

const styles = {
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
    logo: {
        width: "64px",
        height: "64px",
    }
};

class ConfigurationMenu extends React.Component {
    constructor(props){
        super(props);
    }
    render(){
        return (
            <MenuItemLink
                to="/configuration"
                primaryText="Text"
                leftIcon={<SettingsIcon />}
            />
        );
    }
}


const CustomUserMenu = (props) => (
    <UserMenu {...props}>
        <ConfigurationMenu />
    </UserMenu>
);


class CustomAppBar extends React.Component {
    constructor(props) {
        super(props);
        this.checkoutLastActivityTime = this.checkoutLastActivityTime.bind(this);
    }

    componentDidMount() {
        setInterval(this.checkoutLastActivityTime, 30000);
        const {dispatch} = this.props;
        dispatch({type: actions.USER_LOAD_FROM_APP_BAR});
    }

    checkoutLastActivityTime() {
        const {lastActivityTime} = this.props;
        if (lastActivityTime === null){
            return;
        }
        const lastDate = new Date(lastActivityTime);
        const now = new Date();
        const delta = (now - lastDate) / 1000;
        if (delta >= LIMIT_SECS) {
            if (process.env.NODE_ENV === "production") {
                this.props.userLogout();
            }
        }
    }

    render() {
        const {classes, dispatch, lastActivityTime, userLogout, fullName, userEmail, ...props} = this.props;
        let topString = 'PowerDotMT Control Panel';
        let userString = '';
        if (fullName) {
            userString = `${fullName}`
        }

        if (userEmail) {
            if (userString){
                userString = `${userString} <${userEmail}>`;
            } else {
                userString = `<${userEmail}>`;
            }
        }
        if (userString) {
            topString = `${topString} (${userString})`;
        }
        return (
            <AppBar {...props}>
                <Typography
                    variant="title"
                    color="inherit"
                    className={classes.title}
                    id="react-admin-title"
                />
                {topString}
                <span className={classes.spacer} />
            </AppBar>
        );
    }
}

const mapStateToProps = state => ({
    lastActivityTime: getActivityTime(state),
    fullName: getUserFullName(state),
    userEmail: getUserEmail(state),
})

const enhance = compose(
    withDataProvider,
    withStyles(styles),
    connect(mapStateToProps, {userLogout}),
)

export default enhance(CustomAppBar);
